import { getStackTrace, log } from '@src/Log.init';
import { rootApi } from './root.api';

export const parameterApi = rootApi.injectEndpoints({
  tagTypes: ['Parameter'],
  endpoints: (builder) => ({
    getParameterDictionary: builder.query({
      query: () => ({
        url: 'parameterdictionary',
        method: 'GET',
      }),
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'getParameterDictionary: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'getParameterDictionary: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getParameterDictionary: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getClientParameterDictionary: builder.query({
      query: () => ({
        url: 'parameterdictionary/client',
        method: 'GET',
      }),
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'getClientParameterDictionary: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'getClientParameterDictionary: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getClientParameterDictionary: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    updateParameterDictionary: builder.mutation({
      query: (parameter) => ({
        url: 'parameterdictionary',
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: parameter,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'updateParameterDictionary: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'updateParameterDictionary: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'updateParameterDictionary: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getTemplateDictionary: builder.query({
      query: () => ({
        url: 'templatedictionary',
        method: 'GET',
      }),
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'getTemplateDictionary: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'getTemplateDictionary: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getTemplateDictionary: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getClientTemplateDictionary: builder.query({
      query: () => ({
        url: 'templatedictionary/client',
        method: 'GET',
      }),
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'getClientTemplateDictionary: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'getClientTemplateDictionary: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getClientTemplateDictionary: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    updateTemplateDictionary: builder.mutation({
      query: (parameter) => ({
        url: 'templatedictionary',
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: parameter,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'updateTemplateDictionary: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'updateTemplateDictionary: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'updateTemplateDictionary: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getParameterLists: builder.query({
      query: () => ({
        url: 'parametersets',
        method: 'GET',
      }),
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'getParameterLists: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'getParameterLists: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getParameterLists: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    updateParameters: builder.mutation({
      query: (parameter) => ({
        url: 'parameter',
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: parameter,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'updateParameters: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'updateParameters: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'updateParameters: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    addParameterSet: builder.mutation({
      query: (parameterSet) => ({
        url: 'parameter',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: parameterSet,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'addParameterSet: pending',
        });
        // Manually update the cache for getParameterLists
        const postResult = dispatch(
          parameterApi.util.updateQueryData(
            'getParameterLists',
            undefined,
            (draft) => {
              if (draft && Array.isArray(draft)) {
                draft.push(arg);
              }
            }
          )
        );
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'addParameterSet: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'addParameterSet: failure',
            meta_data: getStackTrace(),
            error,
          });

          postResult.undo(); // Rollback the optimistic update if the query fails
        }
      },
    }),
    deleteParameterSet: builder.mutation({
      query: (set) => ({
        url: 'parameter',
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: set,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'deleteParameterSet: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'deleteParameterSet: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'deleteParameterSet: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getTemplateSets: builder.query({
      query: () => ({
        url: 'templatesets',
        method: 'GET',
      }),
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'getTemplateSets: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'getTemplateSets: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getTemplateSets: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    updateTemplateSet: builder.mutation({
      query: (template) => ({
        url: 'parameter',
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: template,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'updateTemplateSet: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'updateTemplateSet: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'updateTemplateSet: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    addTemplateSet: builder.mutation({
      query: (templateSet) => ({
        url: 'parameter',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: templateSet,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'addTemplateSet: pending',
        });
        // Manually update the cache for getTemplateSets
        const postResult = dispatch(
          parameterApi.util.updateQueryData(
            'getTemplateSets',
            undefined,
            (draft) => {
              if (draft && Array.isArray(draft)) {
                draft.push(arg);
              }
            }
          )
        );
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'addTemplateSet: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'addTemplateSet: failure',
            meta_data: getStackTrace(),
            error,
          });

          postResult.undo(); // Rollback the optimistic update if the query fails
        }
      },
    }),
    deleteTemplateSet: builder.mutation({
      query: (set) => ({
        url: 'parameter',
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: set,
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'deleteTemplateSet: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'deleteTemplateSet: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'deleteTemplateSet: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    searchParameterHistory: builder.query({
      query: ({ criteria }) => {
        const queryString = Object.keys(criteria)
          .map((key) => `${key}=${criteria[key]}`)
          .join('&');
        return {
          url: `parameterhistory?${queryString}`,
          method: 'GET',
        };
      },
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'searchParameterHistory: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'searchParameterHistory: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'searchParameterHistory: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getParameterVersion: builder.query({
      query: (versionId) => ({
        url: `parameterhistory/${versionId}`,
        method: 'GET',
      }),
      providesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'getParameterVersion: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'getParameterVersion: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getParameterVersion: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    setVersionAsCurrent: builder.mutation({
      query: (versionId) => ({
        url: `parameterhistory/${versionId}/setcurrentversion`,
        method: 'PUT',
      }),
      invalidatesTags: ['Parameter'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({
          message_type: 'Parameter',
          message: 'setVersionAsCurrent: pending',
        });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Parameter',
            message: 'setVersionAsCurrent: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'setVersionAsCurrent: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
  }),
});

export const {
  useGetParameterDictionaryQuery,
  useLazyGetParameterDictionaryQuery,
  useGetClientParameterDictionaryQuery,
  useLazyGetClientParameterDictionaryQuery,
  useUpdateParameterDictionaryMutation,
  useGetTemplateDictionaryQuery,
  useLazyGetTemplateDictionaryQuery,
  useGetClientTemplateDictionaryQuery,
  useLazyGetClientTemplateDictionaryQuery,
  useUpdateTemplateDictionaryMutation,
  useGetParameterListsQuery,
  useLazyGetParameterListsQuery,
  useUpdateParametersMutation,
  useAddParameterSetMutation,
  useDeleteParameterSetMutation,
  useGetTemplateSetsQuery,
  useLazyGetTemplateSetsQuery,
  useUpdateTemplateSetMutation,
  useAddTemplateSetMutation,
  useDeleteTemplateSetMutation,
  useLazySearchParameterHistoryQuery,
  useLazyGetParameterVersionQuery,
  useSetVersionAsCurrentMutation,
} = parameterApi;
